export enum AppointmentStatus {
  PENDING = 'ausstehend',
  ASSIGNED = 'zugeordnet',
  UNASSIGNED = 'neu',
  CANCELLED = 'abgesagt',
  REJECTED = 'abgelehnt',
  ERROR = 'fehlerhaft',
}
